/**
 * Cross-platform navigation. The app is a Vite + React Router SPA; all
 * navigation uses the same client-side router in web and Capacitor.
 */
import { useCallback } from "react"
import { useNavigate as useReactRouterNavigate } from "react-router-dom"

type NavOptions = { replace?: boolean; state?: unknown }

export function useNavigate() {
  const navigate = useReactRouterNavigate()
  return useCallback(
    (to: string, options?: NavOptions) => {
      navigate(to, { replace: options?.replace, state: options?.state })
    },
    [navigate]
  )
}

/**
 * Full document navigation (e.g. 401) — remounts the app and clears in-memory
 * state.
 */
export function hardNavigate(to: string, options: NavOptions = {}): void {
  if (typeof window === "undefined") return
  if (options.replace) window.location.replace(to)
  else window.location.assign(to)
}
